import React, { Fragment } from 'react';
import { arrayOf, shape, string, number, object } from 'prop-types';
import { useTranslation } from 'react-i18next';

import Accordion from 'components/Accordion';

import ReportCTA from './components/ReportCTA';

function Question({ elementRef, faqs }) {
  const { t } = useTranslation(['course']);
  const FAQ = faqs.length > 0 && (
    <Fragment>
      <h2>{t('videoplayer.label.faq')}</h2>
      <Accordion items={faqs} />
    </Fragment>
  );

  return (
    <Fragment>
      <section ref={elementRef}>
        {FAQ}
        <ReportCTA />
      </section>
    </Fragment>
  );
}

Question.propTypes = {
  elementRef: object.isRequired,
  faqs: arrayOf(
    shape({
      title: string.isRequired,
      content: string.isRequired,
      key: number.isRequired,
    }).isRequired,
  ).isRequired,
};

export default Question;
